
import { Image__curiosity, Image__deep__earth, Image__fisheye, Image__from__above, Image__grid, Image__night__arcade, Image__pocket__borealis, Image__soccer__team, Mob_Image__curiosity, Mob_Image__deep__earth, Mob_Image__fisheye, Mob_Image__from__above, Mob_Image__grid, Mob_Image__night__arcade, Mob_Image__pocket__borealis, Mob_Image__soccer__team } from "../../images";

const cards = [
    {
        image:  Image__deep__earth,
        image1:  Mob_Image__deep__earth,
        text: "DEEP EARTH",
    },
    {
        image: Image__night__arcade,
        image1: Mob_Image__night__arcade,
        text: "NIGHT ARCADE",
    },
    {
        image: Image__soccer__team,
        image1: Mob_Image__soccer__team,
        text: "SOCCER TEAM VR",
    },
    {
        image: Image__grid,
        image1: Mob_Image__grid,
        text: "THE GRID",
    },
    {
        image: Image__from__above,
        image1: Mob_Image__from__above,
        text: "FROM UP ABOVE VR",
    },
    {
        image: Image__pocket__borealis,
        image1: Mob_Image__pocket__borealis,
        text: "POCKET BROEALIS",
    },
    {
        image: Image__curiosity,
        image1: Mob_Image__curiosity,
        text: "THE CURIOSITY",
    },
    {
        image: Image__fisheye,
        image1: Mob_Image__fisheye,
        text: "MAKE IT FISHEYE",
    },
];

export default cards